<template>
  <v-app :dark="!light" :light="light">
    <tud-layout></tud-layout>
  </v-app>
</template>

<script>
  import Layout from '@/components/Layout.vue'
  export default {
    components: {
      'tud-layout': Layout
    },
    computed: {
      light () {
        return this.$store.getters.appLight
      }
    },
    created () {
      this.$store.dispatch('attemptAuth').then(logged => {
        if (this.$store.state.auth.user) {
          if (this.$store.state.auth.user.admin) {
            this.$router.replace({name: 'Dashboard'})
          } else {
            this.$router.replace({name: 'Index'})
          }
        }
      })
    }
  }
</script>

<style lang="stylus">
  @import '../node_modules/vuetify/src/stylus/settings/_colors'
  $theme := {
    primary: #01bd9b
    accent: $blue.accent-2
    secondary: $grey.darken-3
    info: $blue.base
    warning: $amber.base
    error: $red.accent-2
    success: $green.base
  }
  @import './stylus/main'
</style>



// WEBPACK FOOTER //
// App.vue?03566d30